import ErrorOutline from '@material-ui/icons/ErrorOutline'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { toast } from 'react-toastify'

import {
  getPulverizationActivityById,
  GetPulverizationActivityByIdResponse,
} from '@/services/get-pulverization-activity-by-id'

export const GET_PULVERIZATION_ACTIVITY_BY_ID_QUERY = [
  'pulverization-activity-by-id',
]

export const useGetPulverizationActivityById = (activityId?: string) => {
  const query = useQuery<GetPulverizationActivityByIdResponse, Error>(
    [...GET_PULVERIZATION_ACTIVITY_BY_ID_QUERY, { activityId }],
    ({ signal }) => getPulverizationActivityById(activityId!, { signal }),
    {
      enabled: !!activityId,
    },
  )

  useEffect(() => {
    if (!query.isFetching && query.error) {
      toast.error(
        `Não foi possível carregar as informações, tente novamente. [${query.error?.message}]`,
        {
          icon: <ErrorOutline />,
        },
      )
    }
  }, [query.error, query.isFetching])

  return query
}
